import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf188bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-viewer--mp3" }
const _hoisted_2 = { class: "player" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  controls: "",
  ref: "audio"
}
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.instructors[0]?.image,
        alt: _ctx.instructors[0]?.name
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentContent.title), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentContent.description), 1),
      _createElementVNode("audio", _hoisted_6, [
        _createElementVNode("source", {
          src: _ctx.currentContent.file.path,
          type: "audio/mp3"
        }, null, 8, _hoisted_7)
      ], 512)
    ])
  ]))
}